import { TIME_BREAKDOWN_OPTIONS } from './date-picker-group/time-breakdown/constants.tsx';
import messages from './messages.tsx';

export const PAST_48_HOURS_ID = 1;
export const PAST_7_DAYS_ID = 2;
export const PAST_14_DAYS_ID = 3;
export const PAST_30_DAYS_ID = 4;
export const PAST_QUARTER_BY_DAY_ID = 5;
export const PAST_QUARTER_BY_WEEK_ID = 6;
export const PAST_QUARTER_BY_YEAR_ID = 7;
export const PAST_QUARTER_BY_MONTH_ID = 8;
export const CUSTOM_TIMESCALE_ID = 9;

export const TIMESCALE_OPTIONS = [
	{
		id: PAST_48_HOURS_ID,
		analyticsKey: 'past48hours',
		message: messages.past48Hours,
	},
	{
		id: PAST_7_DAYS_ID,
		analyticsKey: 'past7',
		message: messages.past7Days,
	},
	{
		id: PAST_14_DAYS_ID,
		analyticsKey: 'past14',
		message: messages.past14Days,
	},
	{
		id: PAST_30_DAYS_ID,
		analyticsKey: 'past30',
		message: messages.past30Days,
	},
	{
		id: PAST_QUARTER_BY_DAY_ID,
		analyticsKey: 'pastquarter',
		message: messages.pastQuarterByDay,
	},
	{
		id: PAST_QUARTER_BY_WEEK_ID,
		analyticsKey: 'pastquarterbyweek',
		message: messages.pastQuarterByWeek,
	},
	{
		id: PAST_QUARTER_BY_YEAR_ID,
		analyticsKey: 'pastyearbyweek',
		message: messages.pastYearByWeek,
	},
	{
		id: PAST_QUARTER_BY_MONTH_ID,
		analyticsKey: 'pastquarterbymonth',
		message: messages.pastYearByMonth,
	},
	{
		id: CUSTOM_TIMESCALE_ID,
		analyticsKey: 'custom',
		message: messages.customDates,
	},
] as const;

export const DEFAULT_OPTIONS = {
	timescaleId: PAST_7_DAYS_ID,
	timeBreakdown: TIME_BREAKDOWN_OPTIONS.monthly,
} as const;
